import styled from "styled-components";
import colors from "constants/colors";

export const StyledList = styled.ul`
  list-style-type: none;
`;

export const StyledItem = styled.li`
  font-size: 1em;
  margin-left: -1.5em;
  line-height: 1.8em;
  padding: 3px 0;
  ::before {
    content: "\\25FC";
    color: ${colors.primary};
    font-weight: bolder;
    font-size: 1em;
    display: inline-block; 
    width: 1.4em; 
    margin-left: -1.4em;
  }
`;

